<template>
  <Carousel  v-bind="settings"  class="flex gap-4" :mouse-drag="{ threshold: 0.1 }" :touch-drag="{ threshold: 0.1 }">
    <Slide v-for="(item, index) in items.banners" :key="index" class="block md:p-2">
      <div class="h-[200px] md:w-full flex justify-center cursor-pointer" @click="useBannerAction(item, items.header, index)">
      <NuxtImg :src="item.content.source" alt="Banner image" title="Promotional banner" class="object-fill" quality="90" loading="lazy"  @error="setDefaultImage" :class="[desktopClasses, borderClasses, widthClasses]"/>
      </div>
      </Slide>
      <template #addons>
        <Navigation v-if="!isMobile && items.banners.length > itemsToShow"/>
        <Pagination v-if="items.banners.length > 1" />
      </template>
  </Carousel>
</template>

<script setup>
const { isMobile, isDesktopOrTablet } = useDevice();
const props = defineProps(['items', 'config', 'itemstoshow']);
const itemsToShow = isMobile ? 1 : (props.itemstoshow || 4.2);
const settings = { itemsToShow, autoplay: props.items.banners.length > 1 ? 3000 : 0, wrapAround: props.items.banners.length > itemsToShow, snapAlign: props.items.banners.length > itemsToShow ? 'center' : 'start' };
const desktopClasses = isDesktopOrTablet ? 'rounded-md overflow-hidden' : '';
const borderClasses = props.config.border ? 'border border-stone-200' : '';
const widthClasses = itemsToShow === 1
  ? (isMobile ? 'w-full' : '')
  : '';

const runtimeConfig = useRuntimeConfig()
const setDefaultImage = (event) => {
  event.imageSrc = runtimeConfig.public.defaultProductImage;
}

</script>